<div class="tags" [ngClass]="classes">
  @for (tag of tags$ | async; track tag) {
    <a class="tags__link" [appTag]="tag">
      {{ tag }}
    </a>
  }
</div>
